<template>
	<div v-on:mouseenter="mouseEnter" style="display: inline-block;">
		<div class="flex order-link">
			<a class="order-link-link" :href="'/#/order/' + id"><strong>{{ id }}</strong></a>
			<!-- <div class="order-link-button">
				<a target="_blank" :href="`${wp_url}/post.php?post=` + id + '&action=edit'">
					<SvgIcon name="wordpress" />
				</a>
			</div>
			<div class="order-link-button">
				<a :href="'/#/order/' + id + '/diagnostics'">
					<SvgIcon name="track" />
				</a>
			</div> -->
			<div class="order-link-button">
				<SvgIcon name="settings" v-on:click="$refs.dropdown.toggle()" />
				<OrderDropdown v-if="dropDownCreated" ref="dropdown" :id="id" />
			</div>
		</div>
	</div>
</template>

<script>
import OrderDropdown from './OrderDropdown.vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    wp_url: process.env.VUE_APP_WP_URL,
  	dropDownCreated: false
  }),
  methods: {
  	mouseEnter () {
  		if (this.dropDownCreated) {
  			return
  		}
  		this.dropDownCreated = true
  	}
  },
  components: {
    OrderDropdown
  }
}
</script>

<style type="text/css" lang="less">
	.order-link {
		.order-link-link {
			margin-right: 2px;
		}
		.order-link-button {
			margin-left: 4px;
			> .svg-icon svg {
				width: 18px !important;
				height: 18px !important;
				fill: #555;
				cursor: pointer;
			}
			&:hover {
				> .svg-icon svg {
					fill: #222;
				}
			}
		}
	}
</style>
